var React = require('react');

function ZapCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M136.5 253C211.887 253 273 191.887 273 116.5C273 41.1131 211.887 -20 136.5 -20C61.1131 -20 0 41.1131 0 116.5C0 191.887 61.1131 253 136.5 253ZM146.101 38.951C149.329 40.1394 151.292 43.4167 150.817 46.8234L143.893 96.4699H177.938C180.586 96.4699 183.027 97.9015 184.32 100.213C185.612 102.524 185.555 105.353 184.169 107.609L133.635 189.89C131.855 192.789 128.312 194.077 125.086 192.999C121.86 191.92 119.804 188.76 120.124 185.374L125.431 129.329H95.0627C92.3935 129.329 89.9364 127.874 88.6522 125.534C87.3679 123.195 87.4607 120.341 88.8941 118.089L137.406 41.8863C139.253 38.9846 142.873 37.7627 146.101 38.951Z","fill":"#DEE0F7"}));
}

ZapCircle.defaultProps = {"aria-hidden":"1","width":"273","height":"273","viewBox":"0 0 273 232","fill":"none"};

module.exports = ZapCircle;

ZapCircle.default = ZapCircle;
